<template>
    <div>
        <v-list-item-avatar
            :size="size"
            style="overflow: visible"
            :class="[noShadow ? null : 'shadow-grey', margin, getStatus.color]"
            ><v-img :src="getStatus.image" :class="getStatus.shadow"></v-img>
        </v-list-item-avatar>
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: {
        event: {},
        margin: {
            type: String,
            default: "mr-0",
        },
        noShadow: {
            type: Boolean,
            default: false,
        },
        purchaseOption: {
            type: Object,
            default: null,
        },
        size: {
            type: [Number, String],
            default: 48,
        },
        showGroupStatus: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        getPaymentStatus() {
            // handle event in series
            let option = this.purchaseOption;
            if (!option) {
                /*if (this.event.group_event_id || this.event.group_event)
                    return "Paid";*/
                return "Error";
            }

            if (option.ends_at) {
                return option.ends_at >
                    // if this.event is a lesson, compare to lesson date, otherwise compare to now
                    (this.event?.id
                        ? this.globalMoment(this.event.starts_at)
                        : this.globalMoment())
                    ? "Cancelled"
                    : "Unpaid";
            }

            if (option.category == "memberships") {
                return option.subPaid ? "Paid" : "Unpaid";
            }

            return option.paid ? "Paid" : "Unpaid";
        },
        statusMap() {
            return {
                Error: {
                    color: "soli-status-red",
                    image: "/contact-admin.png",
                    shadow: "unpaid-shadow",
                },
                Unpaid: {
                    color: "soli-status-red",
                    image: "/unpaid.png",
                    shadow: "unpaid-shadow",
                },
                Cancelled: {
                    color: "soli-status-grey",
                    image: "/cancelled.png",
                    shadow: "cancelled-shadow",
                },
                Paid: {
                    color: this.typeMap[this.getType].color,
                    image: this.typeMap[this.getType].image,
                    shadow: this.typeMap[this.getType].shadow,
                },
            };
        },
        getType() {
            if (this.purchaseOption?.category == "memberships") {
                return "Membership";
            }
            if (this.purchaseOption?.name.includes("First")) {
                return "First Visit";
            }
            if (this.purchaseOption?.category == "offers") {
                return "Offer";
            }
            if (
                this.event?.group_event_id ||
                this.event?.group_event ||
                this.purchaseOption?.is_event
            ) {
                return "Group";
            }
            return this.purchaseOption?.access[0];
        },
        typeMap() {
            return {
                Membership: {
                    image: "/membership.png",
                    color: "soli-status-blue",
                    shadow: "membership-shadow",
                },
                "First Visit": {
                    image: "/1st-visit-pass.png",
                    color: "soli-status-green",
                    shadow: "assessment-shadow",
                },
                "Drop-In": {
                    image: "/pass.png",
                    color: "soli-status-purple",
                    shadow: "pass-shadow",
                },
                Assessment: {
                    image: "/assessment.png",
                    color: "soli-status-green",
                    shadow: "assessment-shadow",
                },
                Group: {
                    color: "soli-status-group",
                    image: "/group-event.png",
                    shadow: "group-shadow",
                },
                Offer: {
                    image: "/special.webp",
                    color: "soli-status-orange",
                    shadow: "pass-orange",
                },
            };
        },
        getStatus() {
            if (!this.purchaseOption) {
                if (this.event?.group_event || this.event?.group_event_id)
                    return this.statusMap.Paid;
                return this.statusMap.Error;
            }
            return (
                this.statusMap[this.getPaymentStatus] ?? this.statusMap.Error
            );
        },
        eventInSeries() {
            if (!this.event) return null;
            return this.event.group_event
                ? !!this.event.group_event.occurrences
                : false;
        },
    },
};
</script>
